/**
 * P-10d (D-71) — the manual work-log form's task list is the "התחל עבודה"
 * list (GET /timer/tasks: only my open tasks). Pure, unit-tested
 * (`src/utils/__tests__/manualWorkLogModel.test.ts`).
 */
import type { StartableTask, Ticket } from '../../types';

/**
 * FIX-B11 (QX-26): the approved months a manual report would fall in. The
 * inputs are local "YYYY-MM-DDTHH:mm" values (Israel time, as the server's
 * monthsOf); a completed task may be reported only in an open month, so a
 * non-empty result disables "שמור". The server still refuses (409).
 */
export function approvedMonthsHit(start: string, end: string, lockedMonths: readonly string[]): string[] {
  const months = new Set<string>();
  for (const v of [start, end]) {
    if (/^\d{4}-\d{2}/.test(v ?? '')) months.add(v.slice(0, 7));
  }
  return Array.from(months).filter((m) => lockedMonths.includes(m)).sort();
}

/** A startable task in the shape the form's pick list and selected-item card read. */
export function startableTaskAsTicket(task: StartableTask, labels?: { company: string; direct: string }): Ticket {
  // D-274b: "ישירות תחת OTE" reads "עבודה פנימית OTE · ישירות תחת OTE", never "OTE · עבודה פנימית".
  const direct = task.direct_under_ote === true && !!labels;
  return {
    id: task.id,
    title: task.title,
    status: task.status,
    task_type: 'task',
    ticket_number: task.ticket_number ?? undefined,
    organization_id: task.organization_id ?? undefined,
    organization_name: direct ? labels!.company : (task.organization_name ?? undefined),
    // `taskContainerLabel` reads the project first: the container IS the project or the engagement.
    project_name: direct ? labels!.direct : (task.container_name ?? undefined),
    milestone_name: task.milestone_name ?? undefined,
  } as unknown as Ticket;
}
